import { z } from 'zod';
import { zStringRequired } from '../../z';
import { registry } from '../registry';
export const visitTypeOptions = [
    { value: 'counseling', label: 'Counseling' },
    { value: 'linkage to community services', label: 'Linkage to community services' },
    {
        value: "assessment and resolution of social and/or emotional factors that may/are impeding effective treatment of the patient's condition or rate of recovery",
        label: "Assessment and resolution of social and/or emotional factors that may/are impeding effective treatment of the patient's condition or rate of recovery",
    },
];
export const baseMSWAssessment = z.object({
    numberOfVisits: z.string().optional().nullable().register(registry, { label: 'Number of Visits' }),
    visits: z.array(z.string()).optional().register(registry, { label: 'Visits', options: visitTypeOptions }),
    physicalStatus: z.string().optional().nullable().register(registry, { label: 'Physical Status' }),
    mentalStatus: z.string().optional().register(registry, { label: 'Mental Status' }),
    emotionalStatus: z.string().optional().register(registry, { label: 'Emotional Status / Coping Ability' }),
    funcStatus: z.string().optional().register(registry, { label: 'Functional Status' }),
    healthStatus: z.string().optional().register(registry, { label: 'Health Status' }),
    financialStatus: z.string().optional().register(registry, { label: 'Financial Status' }),
    vulnerable: z.string().optional().register(registry, { label: 'Vulnerable to abuse / neglect / exploitation' }),
    appropriateness: z.string().optional().register(registry, {
        label: 'Appropriateness of current environment based on care needs',
    }),
    livingEnv: z.string().optional().register(registry, { label: 'Living environment safety issues' }),
    econIssues: z.string().optional().register(registry, { label: 'Economic issues affecting health / care' }),
    envOther: z.string().optional().register(registry, { label: 'Other' }),
    patientAssessmentComments: z.string().optional().register(registry, { label: 'Comments' }),
    patientAssessment: z.boolean().optional().register(registry, {
        label: "Assessment of the relationship of the patient's medical and nursing requirements to the patient's home situation, financial resources, and availability of community resources",
    }),
    communityLinkageComments: z.string().optional().register(registry, { label: 'Comments' }),
    communityLinkage: z.boolean().optional().register(registry, {
        label: "Linkage to community resources to assist in resolving the patient's problem",
    }),
    counselingServicesComments: z.string().optional().register(registry, { label: 'Comments' }),
    counselingServices: z.boolean().optional().register(registry, { label: 'Counseling services required by the patient' }),
    medicalSocialServicesComments: z.string().optional().register(registry, { label: 'Comments' }),
    medicalSocialServices: z.boolean().optional().register(registry, {
        label: "Medical social services provided to the patient's family or caregiver to remove a clear and direct impediment to the effective treatment of the patient's medical condition or rate of recovery",
    }),
    desiredOutcome: z.string().optional().register(registry, { label: 'Desired Outcome' }),
    mswGoal: z.string().optional().register(registry, { label: 'Goal' }),
    followUpPlan: z.string().optional().register(registry, { label: 'Plan' }),
});
export const mswAssessmentValidationSchema = z.object({
    id: z.string(),
    data: baseMSWAssessment,
    signedUserId: zStringRequired(),
    signedUserDate: zStringRequired(),
});
